<template>
	<div class="tokens-short">
		<div class="tokens-short__icon-container">
			<FontAwesomeIcon
				class="tokens-short__icon"
				icon="far fa-bolt" />
		</div>
		<div class="tokens-short__content">
			<div class="tokens-short__title">You're {{ tokensShort }} tokens short</div>
			<div class="tokens-short__desc">
				You have {{ tokensOwned }} tokens and need {{ tokensNeeded }} to generate this project.
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'

defineProps<{
	tokensNeeded: number
	tokensShort: number
	tokensOwned: number
}>()
</script>

<style scoped lang="scss">
.tokens-short {
	background: #fffae8;
	border: 1px solid rgba(194, 120, 0, 0.25);
	border-radius: 12px;
	padding: 16px;
	display: flex;
	gap: 12px;
	align-items: flex-start;

	.tokens-short__icon-container {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		min-width: 30px;
		min-height: 30px;
		border-radius: 100%;
		background: rgba(238, 255, 1, 0.3);

		.tokens-short__icon {
			color: var(--p-yellow-800);
		}
	}

	.tokens-short__title {
		color: #8b3b00;
		font-weight: 700;
	}

	.tokens-short__desc {
		margin-top: 6px;
		color: #8b3b00;
	}
}
</style>
